const _resolveBaseURL = () => {
  if (process.env.REACT_APP_API_BASE_URL) return process.env.REACT_APP_API_BASE_URL;
  const h = window.location.hostname;
  if (h.includes('localhost') || h.includes('127.0.0.1')) return 'http://localhost:5500/api';
  if (process.env.NODE_ENV === 'production') return `https://${h}/api`;
  return 'http://localhost:5500/api';
};

export const API_CONFIG = {
  baseURL: _resolveBaseURL(),

  timeout: 30000,
  inactivityTimeout: 2 * 60 * 60 * 1000, // 2 hours

  stripePublishableKey:
    process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_placeholder',

  paypalClientId:
    process.env.REACT_APP_PAYPAL_CLIENT_ID ||
    'ASoVfVDYN6VJ2inIqeZzFaOm_qaWuKiB5a9Li4XXyfXy-aV8scj24un2m1IuCE0fXJ7r00LyiPRXb_ww',
};

export const STRIPE_PUBLISHABLE_KEY = API_CONFIG.stripePublishableKey;
export const PAYPAL_CLIENT_ID = API_CONFIG.paypalClientId;
